// @flow
import type { RouteDataType } from 'shared/routing/routeDataTypes';
import type { Store } from 'redux';
import { experienceFetchComplete } from 'app/common/redux/actions/experiences';
import { resourceFetchComplete } from 'app/common/redux/actions/resourceFetch';
import {
  mainComponentSet,
  mainComponentInitSet,
  locationToErrorMapEntrySet,
  upwtActionNameSet,
} from 'app/common/redux/actions/mainComponent';

type ResourceResponse = {
  // $FlowFixMe Flow v0.104.0 upgrade supression.
  name: *,
  options?: Object,
  response: { data: mixed, error: any },
  nextBookmark: string,
};
export default function populateStore(
  // $FlowFixMe: New error after Flow Upgrade http://pinch.pinadmin.com/flow53upgdoc
  store: Store,
  routeData: RouteDataType,
  resourceResponses: ResourceResponse[],
  dataProps: Object,
  renderError?: ?Object,
): void {
  // Cache prefetched resources
  resourceResponses.forEach(({ name, options, response, nextBookmark }) => {
    store.dispatch(
      resourceFetchComplete(name, options, response.data, response.error, nextBookmark),
    );
  });

  const { name, upwtActionName, placedExperience, placementId } = routeData;

  // Set the initial component name and current since this is first page load
  store.dispatch(mainComponentSet(name));
  store.dispatch(mainComponentInitSet(name));

  // Set the UPWT action name if we have one
  if (upwtActionName) {
    store.dispatch(upwtActionNameSet(upwtActionName));
  }

  if (placedExperience && placementId) {
    store.dispatch(experienceFetchComplete({ [placementId]: placedExperience }, placementId));
  }
  // If there is a renderError, set the error in a location map so components have access to it
  // and can handle it appropriately
  if (renderError) {
    store.dispatch(locationToErrorMapEntrySet(dataProps.location.pathname, renderError));
  }
}
